module.exports = __webpack_public_path__ + "img/no_movement_gray.ec169891.svg";